
import React, { Component } from 'react';
import ReactDOM from 'react-dom';


const ParkingAddCarrier = (props) => {

    const handleRouteClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.formGridCarrierHandler(props.data);
    };
    return (
        <div className="map-icon-component">
			     <button onClick={handleRouteClick} className="btn btn-info btn-xs" title="Report Carrier">Report Carrier </button>
        </div>
    );
};

export default ParkingAddCarrier;
